import { render } from "./StoreList.vue?vue&type=template&id=3355b0d2&scoped=true"
import script from "./StoreList.vue?vue&type=script&lang=js"
export * from "./StoreList.vue?vue&type=script&lang=js"

import "./StoreList.vue?vue&type=style&index=0&id=3355b0d2&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3355b0d2"]])

export default __exports__